// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';
import { propertiesSelector } from '../../feature';

// Components
import { StyledCell, StyledContainer, StyledRow, StyledText } from './OwnerAndPropertyContainerStyles';
import PropertyInformation from '../../components/PropertyInfo/PropertyInfo';
import { StyledLabel, StyledLink } from '../../components';

// Models
import { ROUTES } from '@/models/router.model';

const OwnerAndPropertyContainer = () => {
  const { t } = useTranslation('property');
  const { property } = useAppState(propertiesSelector);

  const { property_owner: propertyOwner } = property ?? {};

  return (
    <StyledContainer>
      <StyledRow>
        <StyledCell>
          <StyledLabel>{t('label_owner_name')}</StyledLabel>
          <StyledLink
            path={{
              pathname: ROUTES.USERS,
              search: new URLSearchParams({ id: propertyOwner?.user_id ?? '' }).toString(),
            }}
          >
            {propertyOwner?.full_name ?? '-'}
          </StyledLink>
        </StyledCell>
        <StyledCell>
          <StyledLabel>{t('label_owner_email')}</StyledLabel>
          <StyledText>{propertyOwner?.email ?? '-'}</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledLabel>{t('label_owner_phone')}</StyledLabel>
          <StyledText>{propertyOwner?.phone_number ?? '-'}</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledLabel>{t('label_address_for_invoicing')}</StyledLabel>
          <StyledText>{propertyOwner?.invoice_address?.full_address ?? '-'}</StyledText>
        </StyledCell>
      </StyledRow>
      {property && <PropertyInformation property={property} />}
      <StyledRow>
        <StyledCell>
          <StyledLabel>{t('property_estimated_nok')}</StyledLabel>
          <StyledText>{property?.final_valuation_price ?? '-'}</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledLabel>{t('property_sold_price')}</StyledLabel>
          <StyledText>{property?.final_sold_price ?? '-'}</StyledText>
        </StyledCell>
      </StyledRow>
    </StyledContainer>
  );
};

export default OwnerAndPropertyContainer;
